import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import MainPreview from "./MainPreview";
// import OptIn from "./OptIn";
import DecisionForm from "./DecisionForm";
import Privacy from "./Privacy";
// import SolutionSpaceDemo from "./pages/SolutionSpaceDemo";


export default function App() {
  return (
    <div className="relative min-h-screen flex flex-col text-egypt-gold bg-egypt-black">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 w-full z-50 bg-egypt-black border-b border-egypt-gold/20 shadow-md">
        <div className="max-w-6xl mx-auto flex items-center justify-between py-4 px-6 text-egypt-gold">
          {/* Logo + Platform Name */}
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="jelliFala Logo" className="h-10 w-auto object-contain align-middle" />
            <span className="font-heading text-xl font-bold leading-none text-egypt-gold hover:text-egypt-cream transition">
              <span className="logo-jelli text-egypt-gold">jelli</span>
              <span className="logo-fala text-egypt-gold">Fⲁⲗⲁ</span>
            </span>
          </Link>

          {/* Nav Links */}
          <div className="flex items-center gap-6">
            <Link to="/" className="hover:text-egypt-cream transition">Home</Link>
            {/* <Link to="/features" className="hover:text-egypt-cream transition">Features</Link> */}
            <Link to="/decision" className="hover:text-egypt-cream transition">Decision Tool</Link>
          </div>
        </div>
      </nav>

      {/* Page container */}
      <main className="flex-grow pt-24">
        <Routes>
          <Route path="/" element={<MainPreview />} />

          {/*
          <Route
            path="/features"
            element={
              <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <OptIn />
              </div>
            }
          />
          */}

          <Route path="/decision" element={<DecisionForm />} />

          <Route
            path="/privacy"
            element={
              <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <Privacy />
              </div>
            }
          />

          {/*
          <Route
            path="/demo-fala-7k92m"
            element={<SolutionSpaceDemo />}
          />
          */}

          <Route path="*" element={<MainPreview />} />
        </Routes>
      </main>

      <footer className="bg-egypt-blackSoft text-egypt-gold py-4 text-center relative">
        <p className="inline-flex items-center justify-center gap-2">
          © {new Date().getFullYear()} All rights reserved – jelliFala ·{" "}
          <Link
            to="/privacy"
            className="hover:text-egypt-cream underline transition"
          >
            Privacy
          </Link>{" "}
          ·{" "}
          <span className="relative group inline-block">
            <a
              href="mailto:contact@jellifala.com"
              className="hover:text-egypt-cream underline transition"
            >
              Contact
            </a>
            <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-xs px-3 py-1 text-sm text-egypt-black bg-egypt-cream rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              Send feedback or questions
            </span>
          </span>
        </p>
      </footer>
    </div>
  );
}